(function () {
    'use strict';

    angular.module("imApp").factory("deliveryMethodBusinesscoService", ['$ihttp', function ($ihttp) {
        let service = {
            listBusinesses: function (parms) {
                return $ihttp.post({
                    method: 393,
                    parameters: parms || {}
                });
            },
            toggleItems: function (items) {
                return $ihttp.post({
                    method: 397,
                    parameters: items
                });
            }
        };

        return service;
    }]);
})();
